import { render, staticRenderFns } from "./StaffVehiclesForm.vue?vue&type=template&id=d8f4c382"
import script from "./StaffVehiclesForm.vue?vue&type=script&lang=js"
export * from "./StaffVehiclesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports